"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolate = interpolate;
const hasReact = (params) => Object.values(params).some((v) => v !== null &&
    v !== undefined &&
    typeof v !== 'string' &&
    typeof v !== 'number' &&
    typeof v !== 'boolean');
function interpolate(str, params) {
    if (Array.isArray(params)) {
        const positionalParams = params;
        const hasReactParams = hasReact(positionalParams);
        const re = () => /(%s)/g;
        let i = 0;
        if (hasReactParams) {
            return str
                .split(/(%s)/g)
                .filter((w) => !!w)
                .map((w) => {
                var _a, _b;
                const [, key] = (_a = re().exec(w)) !== null && _a !== void 0 ? _a : [];
                if (!key) {
                    return w;
                }
                else {
                    return ((_b = positionalParams[i++]) !== null && _b !== void 0 ? _b : (console.error(`Missing param ${i} in the string "${str}"`), w));
                }
            });
        }
        else {
            return str.replace(re(), (_) => { var _a; return String((_a = positionalParams[i++]) !== null && _a !== void 0 ? _a : _); });
        }
    }
    else {
        const namedParams = params;
        const hasReactParams = hasReact(namedParams);
        const re = () => /%{([^}]*)}/g;
        if (hasReactParams) {
            return str
                .split(/(%{[^}]*})/g)
                .filter((w) => !!w)
                .map((w) => {
                var _a, _b;
                const [, key] = (_a = re().exec(w)) !== null && _a !== void 0 ? _a : [];
                if (!key) {
                    if (key === '') {
                        console.error(`Empty param in the string "${str}"`);
                    }
                    return w;
                }
                else {
                    return ((_b = namedParams[key]) !== null && _b !== void 0 ? _b : (console.error(`Missing param "${key}" in the string "${str}"`),
                        w));
                }
            });
        }
        else {
            return str.replace(re(), (_, key) => { var _a; return String((_a = namedParams[key]) !== null && _a !== void 0 ? _a : _); });
        }
    }
}
